import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export const SITE_URL = 'https://www.alturionlabs.com';

export function PrerenderReady({ when = true }) {
  useEffect(() => {
    if (when) {
      document.documentElement.setAttribute('data-prerender-ready', 'true');
    } else {
      document.documentElement.removeAttribute('data-prerender-ready');
    }
    return () => {
      document.documentElement.removeAttribute('data-prerender-ready');
    };
  }, [when]);

  return null;
}

const Seo = ({ title, description, path = '/', ready = true }) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'fr').startsWith('en') ? 'en' : 'fr';
  const canonicalPath = path.startsWith('/') ? path : `/${path}`;
  const url = `${SITE_URL}${canonicalPath === '/' ? '/' : canonicalPath}`;

  return (
    <>
      <Helmet htmlAttributes={{ lang }}>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
      </Helmet>
      <PrerenderReady when={ready} />
    </>
  );
};

export default Seo;
